/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createScenarioDependencyRestRequestSchema = z.object({
  predecessorId: z.int().nullish(),
  successorId: z.int().nullish(),
  waitDays: z.int().nullish(),
});
